export function GetDefaultServiceAppointmentData() {
    return {
        id: null,
        number: '',
        type: null,
        project: null,
        order: null,
        address: '',
        assignee: null,
        description: '',
        expected_duration: null,
        travel_duration: null,
        time_range_start: '',
        time_range_end: '',
        ticket: null,
        creator: null,
        created_at: '',
        canceler: null,
        canceled_at: '',
        canceled_reason: '',
        attachments: [],
        newAttachments: [],
        shop_drawing_url: '',
        service_times: [],
        status: null,
        damage_tickets: [],
        location: null,
        responsible_party_type: null,
        contacts: [
            {
                name: '',
                email: '',
                phone: ''
            }
        ],
    };
}
